export class Company {
  id = '';
  name = '';
  address = '';
  address_1 = '';
  address_2 = '';
  address_3 = '';
  address_4 = '';
  postcode = '';
  contact_Name = '';
  contact_Email = '';
  contact_Phone = '';
  account_Number = '';
  userId = '';
  expired = false;
  addLocation = false;

  is_edit: Boolean = false;
}
